module.exports = __webpack_public_path__ + "img/Kickstarter-page-800x650.b539709d.png";